export default __webpack_public_path__ + "static/media/chf-flag.2c1b465d.svg";